<template>
  <div class="text_label">
    <div class="label mb-1" :class="{ bold: labelBold }">
      <slot name="label">
        <span>{{ text }}</span>
      </slot>
    </div>
    <div class="value" :class="{ bold: valueBold }">
      <slot>
        <span>{{ value || 'None' }}</span>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, default: '' },
    value: { type: String, default: '' },
    labelKey: { type: String, default: '' },
    labelBold: { type: Boolean, default: false },
    valueBold: { type: Boolean, default: true },
  },
  computed: {
    text() {
      if (!this.labelKey) return this.label || ''
      return this.$l(this.labelKey)
    },
  },
}
</script>

<style lang="scss" scoped>
.text_label {
  font-size: 14px;
  .bold {
    font-weight: bold;
  }
  .value {
    line-height: 1.3;
    white-space: pre-line;
    word-wrap: break-word;
    word-break: break-all;
  }
}
</style>
